import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';
import titleize from 'titleize';
import NgssTagGroup from './NgssTagGroup';
import '../assets/css/components/popups.css';
import '../assets/css/components/assignment-popup.css';

const AssignmentPopupTemporary = ({ assignableContent, resultsCollection, onSubmitNew, resetForm, studentGroupings, handleClose, isFetching, isSubmitting, submitError, fetchedRequestId, submitWasSuccessful }) => {
  const ngssContentCount = ()=> {
    if(!assignableContent){ return 0 }
    return _.isEmpty(assignableContent) ? 0 : _.compact(_.flatten([assignableContent.ngss_seps, assignableContent.ngss_dcis, assignableContent.ngss_cccs, assignableContent.ngss_pes])).length;
  }

  const getContentType = ()=>titleize(pluralize.singular(assignableContent.type))

  return(
    <div className='assignment-popup popup-content popup dialog responsive-popup dialog--open'>
      <div onClick={()=>{handleClose(); resetForm()}} className='popup-background'></div>
      {assignableContent &&
        <div className="dialog__content">
          <div className="container-fluid">
            <div className="dialog__overview">
              <div id="standard-col" className="col-md-6 p-r-35 p-t-35 p-l-35 item-description bg-immersed-primary">
                <span className="label font-montserrat fs-11 card-type">{getContentType()}</span><br/><br/>
                <h2 className="semi-bold no-margin font-montserrat text-white" id="assignableContent-name">{assignableContent.name || assignableContent.title}</h2>
                <br/>
                {(assignableContent.educational_description || assignableContent.description) &&
                  <div>
                    <p className="fs-13 text-white" id="assignableContent-educational-description">{assignableContent.educational_description || assignableContent.description}</p>
                    <br/>
                  </div>
                }
                {ngssContentCount() === 0 &&
                  <b><p className="fs-13 text-white">There's no NGSS content associated with this {getContentType().toLowerCase()}.</p></b>
                }
                {ngssContentCount() !== 0 &&
                  <NgssTagGroup objectWithNgssTags={assignableContent} size='small'/>
                }
                <br/><br/>
              </div>
              <div id="assignableContent-col" className="col-md-6 p-r-35 p-t-35 p-l-35 item-description">
                <span className="label font-montserrat fs-11">Assign</span><br/><br/>
                {/*<span className="label font-montserrat fs-11" style={{visibility: 'hidden'}}></span>

                <ul className="nav nav-tabs nav-tabs-fillup" data-init-reponsive-tabs="dropdownfx">
                  <li className="nav-item">
                    <a href="#" className="active" data-toggle="tab" data-target="#tab-fillup1"><span>Create</span></a>
                  </li>
                  <li id='edit-assignment-tab' className="nav-item">
                    <a href="#" data-toggle="tab" data-target="#tab-fillup2"><span>Modify</span></a>
                  </li>
                </ul>*/}
                <div className="tab-content">
                  <div className="tab-pane active" id="tab-fillup1">
                    {/*<h2 className="semi-bold no-margin font-montserrat" id="standard-title">Assign <span className='card-type'>Quest</span></h2>*/}
                    <br/>
                    <div id='assignment-form-wrapper'>
                      <div className='empty-classes-notice'>
                        <h2>Homeschooler assignment coming soon</h2>
                        <p>Once released, parents that opt into our homeschooler program can create and manage assignments for their children.</p>
                      </div>
                    </div>
                    <br/>
                  </div>

                  <div className="tab-pane" id="tab-fillup2">
                    <h2 className="semi-bold no-margin font-montserrat" id="standard-title">Edit Assignments</h2>
                    <div id='edit-assignment-form-wrapper'></div>
                    <br/><br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button onClick={()=>{handleClose(); resetForm()}} className="popup-close close action top-right" data-dialog-close=""><i className="fa fa-times"></i></button>
        </div>
      }
    </div>
  );
}

export default AssignmentPopupTemporary;
